import { EquipmentProjectApiModel } from '@/core/models/api/equipment-project-api-model.model';

export interface EquipmentProjectState {
  items: EquipmentProjectApiModel[];
  loadedProjectId: number | null;
  loading: boolean;
  saving: boolean;
  error: any;
}

export const initialEquipmentProjectState: EquipmentProjectState = {
  items: [],
  loadedProjectId: null,
  loading: false,
  saving: false,
  error: null,
};
